import Debug from '@/util/debug';

const debug = Debug('location-type-selector');

export default {
  props: {
    options: Array,
    selected: Array,
  },
  methods: {
    toggle(type) {
      debug.info('selected: %j', type);
      this.$emit('update:selected', [type]);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/location-type-selector/LocationTypeSelector.js